/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
import { FEATURE_NAMES } from '../../loaders/features/features';
export const FEATURE_NAME = FEATURE_NAMES.ajax;
export const AJAX_ID = 'ajaxRequest.id';